import type { QueueStatus } from "../types";

const labels: Record<QueueStatus, string> = {
  WAITING: "กำลังรอ",
  CALLED: "กำลังเรียก",
  COMPLETED: "เสร็จสิ้น",
  CANCELLED: "ยกเลิก",
  NO_SHOW: "ไม่มา",
};

export function StatusBadge({ status }: { status: QueueStatus }) {
  return <span className={`status status--${status.toLowerCase()}`}>{labels[status]}</span>;
}
